import React, { Component, PropTypes } from 'react';
import { Button, Modal, Input, Form, Select, InputNumber, DatePicker } from 'antd';
import { FacebookLogin } from 'components';
import cn from 'classnames';
import Utils from 'utils/utils';
import { formItemLayout } from 'constants/layout';
import _ from 'lodash';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { addPoints } from 'data/user';
import { connect } from 'react-redux';

const Option = Select.Option;

const FormItem = Form.Item;
const { TextArea } = Input;
const customStyles = {
  overlay: {
    zIndex: 2000,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

class AddPoint extends Component {
  static defaultProps = {
    student: {},
  };
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isShow: true,
      expiredDate: moment().add(3, 'month').startOf('day'),
    };
    // this.login = this.login.bind(this);
  }

  handleSubmit(e) {
    // return;
    e.preventDefault();
    const props = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const params = {
          ...values,
          expired: values.expired.toDate(),
        };
        console.log(params);

        addPoints(this.props.student._id, {
          ...params,
        }).then(async () => {
          await props.reload();
          props.handleCancel();
        });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const student = this.props.student;

    return (
      <Modal
        title={'Add Points'}
        visible={this.state.isShow}
        onCancel={this.props.handleCancel}
        footer={[
          <Button key="back" size="large" onClick={this.props.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmit}>
            Save
          </Button>,
        ]}
      >
        <div className={'padding-bottom-30'}>
          <div>
            <span className="bold">Student: </span> {`${_.get(student, 'name.first')} ${_.get(student, 'name.last')}`}
          </div>
        </div>

        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Points" hasFeedback>
            {getFieldDecorator('points', {
              rules: [
                {
                  required: true,
                  type: 'number',
                  message: 'Please input points',
                },
              ],
              initialValue: 500,
            })(<InputNumber />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Expired" hasFeedback>
            {getFieldDecorator('expired', {
              rules: [
                {
                  required: true,
                  type: 'object',
                },
              ],
              initialValue: this.state.expiredDate,
            })(<DatePicker />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Remark" hasFeedback>
            {getFieldDecorator('remark', {
              rules: [
                {
                  required: false,
                  // message: 'Please input Page',
                },
              ],
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(AddPoint);
